<template>
  <div v-if="this.rootStore.officeDL.length > 0">
    <div class="row" id="calloutsRow">
      <div class="col-md-3 col-lg-2">
        <div class="card h-100">
          <div class="card-header">
            <h6 class="card-title">Open Driver License Offices</h6>
          </div>
          <div class="card-body"></div>
          <div class="card-footer">
            <span class="card-text">{{ this.rootStore.officeDL.length }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-3 col-lg-2">
        <div class="card h-100">
          <div class="card-header">
            <h6 class="card-title">Open License Plate Offices</h6>
          </div>
          <div class="card-body"></div>
          <div class="card-footer">
            <span class="card-text">{{ this.rootStore.officeLPA.length }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-3 col-lg-2" v-if="this.rootStore.officeKAllKiosks.length > 0">
        <div class="card h-100">
          <div class="card-header">
            <h6 class="card-title">Kiosk Locations</h6>
          </div>
          <div class="card-body"></div>
          <div class="card-footer">
            <span class="card-text">{{ this.rootStore.officeKAllKiosks.length }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-3 col-lg-2">
        <div class="card h-100">
          <div class="card-header">
            <h6 class="card-title">Open Trucking (IRP)</h6>
          </div>
          <div class="card-body"></div>
          <div class="card-footer">
            <span class="card-text">{{ this.rootStore.officeIRP.length }}</span>
          </div>
        </div>
      </div>


      <div class="col-md-3 col-lg-2">
        <div class="card h-100">
          <div class="card-header">
            <h6 class="card-title">Total Closed Offices</h6>
          </div>
          <div class="card-body"></div>
          <div class="card-footer">
  
            <span class="card-text">{{
              this.rootStore.closedOfficeDL.length +
              this.rootStore.closedOfficeLPA.length +
              this.rootStore.closedOfficeIRP.length +
              this.rootStore.closedOfficeLT.length + 
              this.rootStore.closedOfficeKioskDLVR.length
            }}</span>
            
          </div>
        </div>
      </div>



    </div>
  </div>
</template>

<script>
import { useRootStore } from "../store";

export default {
  name: "CallOuts",
  data() {
    return {
      rootStore: useRootStore()
    }
  }
};
</script>